import { useTranslations } from "contexts/LocalizationContext";
import MenuLink from "modules/common/components/MenuLink";
import type { ResolvedMenuPagePaths } from "utils/menuUtils";

import { Flex, Text } from "@chakra-ui/react";

const Menu = ({ label, menu }: { label?: string; menu: ResolvedMenuPagePaths[] }) => {
  const translations = useTranslations();

  return (
    <Flex direction="column">
      {label && (
        <Text
          textTransform="uppercase"
          fontWeight="semibold"
          fontSize="sm"
          mb={4}
          letterSpacing="0.25px"
          data-testid="footer-category"
        >
          {translations(label)}
        </Text>
      )}
      <Flex direction="column" role="menu" mt={!label ? 4 : 0}>
        {menu &&
          menu.map((item) => {
            const { label: menuItemLabel } = item;

            return (
              <MenuLink
                key={menuItemLabel}
                menuItem={item}
                variant="footerLight"
                fontSize="sm"
                mb={5}
                data-testid="footer-elements"
              />
            );
          })}
      </Flex>
    </Flex>
  );
};

export default Menu;
